/* DEEN size guide (tops, pants, awrah shorts). Loads data + views, then runs. */
(function () {
  'use strict';
  var me = document.currentScript, src = (me && me.src) || '';
  var KIND = window.DTSF_KIND === 'pants' ? 'pants' : window.DTSF_KIND === 'awrah' ? 'awrah' : 'tops', NOBRA = KIND !== 'tops', AWRAH = KIND === 'awrah';
  window.DTSF = window.DTSF || {}; window.DTSF.kind = KIND;
  var base = src.split('?')[0].replace(/deen-tops-sf\.js$/, ''), qs = '?v=' + Math.floor(Date.now() / 600000);
  var TEST = /[?&]dsf_test=1/.test(location.search);
  function load(list, cb) {
    var i = 0;
    (function next() {
      if (i >= list.length) return cb();
      var s = document.createElement('script'); s.src = base + list[i++] + qs; s.async = false; s.onload = next; s.onerror = next; document.head.appendChild(s);
    })();
  }
  function run() {
    var D = window.DTSF, C = window.DEEN_TOPS_SF;
    if (!D || !C || !D.shell || !(C.ready || TEST)) return;
    var t = D.t, ov, KEY = 'dtsf_rec_' + KIND;
    /* UK sizes for GB / IE / AU / NZ visitors, US sizes for everyone else (?dsf_reg=uk to preview) */
    var country = String((window.Shopify && window.Shopify.country) || '').toUpperCase();
    var REG = (/[?&]dsf_reg=uk/.test(location.search) || /^(GB|UK|IE|AU|NZ)$/.test(country)) ? 'uk' : 'us';
    function lab(s) { return s[REG] ? s.n + ' / ' + s[REG] : s.n; }
    var st = { tab: 'calc', step: 1, unit: 'imperial', age: '', w: '', ft: '', inch: '', hcm: '', sys: 'american', band: 28, cup: 'AA', fit: 2, rec: 0, pick: 0, cu: 'in', mb: '', mw: '', mh: '', priv: false, title: '', img: '', p: null };
    var RC = { sizes: C.sizes.map(function (s) { return { n: s.n, l: lab(s) }; }) };
    var RULER = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2" y="7" width="20" height="10" rx="1.5"/><path d="M6 7v4M10 7v3M14 7v4M18 7v3"/></svg>';
    var HANGER = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 8a2.5 2.5 0 1 0-2.5-2.5M12 8v2.5L3 17a1.2 1.2 0 0 0 .8 2h16.4a1.2 1.2 0 0 0 .8-2l-9-6.5"/></svg>';
    function num(v) { return parseFloat(String(v).replace(',', '.')); }
    function parse1() {
      var a = num(st.age), w = num(st.w), h;
      if (st.unit === 'imperial') { var ft = num(st.ft); if (!(ft >= 3 && ft <= 7)) return null; h = (ft * 12 + (num(st.inch) || 0)) * 2.54; w = w * 0.45359; } else h = num(st.hcm);
      if (!(a >= 12 && a <= 100) || !(w >= 30 && w <= 220) || !(h >= 120 && h <= 225)) return null;
      return { a: a, w: w, h: h };
    }
    function parseM() {
      var k = st.unit === 'imperial' ? 1 : 1 / 2.54, b = NOBRA ? 40 : num(st.mb) * k, w = num(st.mw) * k, h = num(st.mh) * k;
      if (!(b >= 25 && b <= 70) || !(w >= 20 && w <= 65) || !(h >= 25 && h <= 75)) return null;
      return { b: b, w: w, h: h };
    }
    function idxBy(k, v) { for (var i = 0; i < C.sizes.length; i++) { if (C.sizes[i][k] >= v) return i; } return C.sizes.length - 1; }
    function clamp(i) { return Math.max(0, Math.min(C.sizes.length - 1, i)); }
    function bandIn(sys, v) {
      v = num(v);
      if (sys === 'european' || sys === 'jkc') return v / 2.54;
      if (sys === 'aunz') return v + 22;
      if (sys === 'frsp') return (v - 15) / 2.54;
      if (sys === 'italian') return (55 + 5 * v) / 2.54;
      return v;
    }
    function braBust() {
      var s = D.bra[st.sys], ci = s.cups.indexOf(st.cup);
      if (!(num(st.band) > 0) || ci < 0) return null;
      return bandIn(st.sys, st.band) + ci;
    }
    function recommend() {
      var p = st.p, bmi = p.w / Math.pow(p.h / 100, 2), a = C.algo, i1, i, bb;
      if (a && a.wStep) i = a.anchor + (p.w - a.w0) / a.wStep + (p.h - a.h0) / a.hStep;
      else if (a) i = a.anchor + (bmi - a.bmi0) / a.bmiStep + (p.h - a.h0) / a.hStep;
      else {
        i1 = clamp((bmi - 17.5) / 3 + Math.max(0, p.h - 172) / 20 + (p.a >= 45 ? 0.3 : 0)); i = i1; bb = NOBRA ? null : braBust();
        if (bb) i = (i1 + idxBy('bust', bb + 1.5)) / 2;
      }
      return clamp(Math.round(i + (st.fit - 3) / 3));
    }
    function saved() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
    function save(n) { try { localStorage.setItem(KEY, n); } catch (e) {} refreshBox(); }
    function boxHtml() {
      var n = saved(), s = n && C.sizes.filter(function (x) { return x.n === n; })[0];
      return RULER + '<span>' + (s ? t('recsz') + ' <b>' + lab(s) + '</b>' : t('findsz')) + '</span>';
    }
    function refreshBox() { [].slice.call(document.querySelectorAll('.dtsf-rbx')).forEach(function (b) { b.innerHTML = boxHtml(); }); }
    function ready() {
      var b = ov.querySelector('[data-a=next1]'), m = ov.querySelector('[data-a=mcalc]');
      if (b) { var ok = !!parse1(); b.disabled = !ok; b.classList.toggle('rdy', ok); }
      if (m) { var ok2 = !!parseM(); m.disabled = !ok2; m.classList.toggle('rdy', ok2); }
    }
    function render() {
      var inner;
      if (st.tab === 'chart') inner = D.chart(st, { sizes: C.table || C.sizes });
      else if (st.step === 1) inner = D.step1(st);
      else if (st.step === 2) inner = D.step2(st);
      else if (st.step === 3) inner = D.step3(st);
      else if (st.step === 'm') inner = D.meas(st);
      else inner = D.result(st, RC);
      ov.querySelector('.dtsf-box').innerHTML = D.shell(st, inner); ready();
    }
    function colour() {
      var fs = [].slice.call(document.querySelectorAll('variant-selects fieldset')).filter(function (f) { var g = f.querySelector('legend'); return g && /colo/i.test(g.textContent); })[0];
      var c = fs && fs.querySelector('input:checked'); return c ? c.value : '';
    }
    function open() {
      var h1 = document.querySelector('.product__title') || document.querySelector('h1'), c = colour();
      st.title = ((h1 && h1.textContent) || '').trim() + (c && !NOBRA ? ' – ' + c : '');
      var og = document.querySelector('meta[property="og:image"]'); st.img = (og && og.content) || '';
      render(); ov.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
    }
    function close() { ov.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    function selectSize(name) {
      var i = [].slice.call(document.querySelectorAll('variant-selects input[type=radio]')).filter(function (x) { return String(x.value).toLowerCase() === String(name).toLowerCase(); })[0];
      if (i) { i.click(); return; }
      [].slice.call(document.querySelectorAll('select')).forEach(function (sel) {
        var o = [].slice.call(sel.options).filter(function (x) { return String(x.value).toLowerCase() === String(name).toLowerCase() || String(x.text).trim().toLowerCase() === String(name).toLowerCase(); })[0];
        if (o && !sel.closest('.dtsf-ov')) { sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    }
    function onClick(e) {
      if (e.target === ov) return close();
      var b = e.target.closest ? e.target.closest('[data-a]') : null; if (!b) return;
      var a = b.getAttribute('data-a'); e.preventDefault();
      if (a === 'close') return close();
      if (a === 'tab-calc') { st.tab = 'calc'; return render(); }
      if (a === 'tab-chart') { st.tab = 'chart'; return render(); }
      if (a === 'u-imperial' || a === 'u-metric') { st.unit = a.slice(2); st.w = st.ft = st.inch = st.hcm = st.mb = st.mw = st.mh = ''; return render(); }
      if (a === 'cu-in' || a === 'cu-cm') { st.cu = a.slice(3); return render(); }
      if (a === 'priv') { st.priv = !st.priv; return render(); }
      if (a === 'know') { st.step = 'm'; return render(); }
      if (a === 'next1') { var p = parse1(); if (!p) return; st.p = p; st.step = NOBRA ? 3 : 2; return render(); }
      if (a === 'next2') { st.step = 3; return render(); }
      if (a === 'back') { st.step = (st.step === 3 && !NOBRA) ? 2 : 1; return render(); }
      if (a === 'calc') { st.rec = st.pick = recommend(); save(C.sizes[st.rec].n); st.step = 'r'; return render(); }
      if (a === 'mcalc') { var m = parseM(); if (!m) return; st.rec = st.pick = clamp(NOBRA ? Math.max(idxBy('waist', m.w + 1), idxBy('hips', m.h + 1.5)) : Math.max(idxBy('bust', m.b + 1.5), idxBy('waist', m.w + 1.5), idxBy('hips', m.h + 1.5))); save(C.sizes[st.rec].n); st.step = 'r'; return render(); }
      if (a === 'again') { st.step = 1; return render(); }
      if (a === 'arrow') { var pl = ov.querySelector('#dtsf-pl'); if (pl) pl.scrollBy({ left: pl.clientWidth * 0.6 * (D.L ? -1 : 1), behavior: 'smooth' }); return; }
      if (a.indexOf('pick-') === 0) { st.pick = parseInt(a.slice(5), 10); return render(); }
      if (a === 'shop') { selectSize(C.sizes[st.pick].n); close(); }
    }
    function build() {
      ov = document.createElement('div'); ov.className = 'dtsf-ov'; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true');
      ov.innerHTML = '<div class="dtsf-box"></div>'; document.body.appendChild(ov);
      ov.addEventListener('click', onClick);
      ov.addEventListener('input', function (e) {
        var f = e.target.getAttribute && e.target.getAttribute('data-f');
        if (f) { st[f] = e.target.value; ready(); }
        if (e.target.id === 'dtsf-rng') {
          st.fit = parseInt(e.target.value, 10); var bub = ov.querySelector('#dtsf-bub');
          if (bub) { bub.textContent = D.FIT[st.fit][D.L]; bub.style.left = 'calc(14px + (100% - 28px) * ' + (st.fit / 6) + ')'; }
        }
      });
      ov.addEventListener('change', function (e) {
        var k = e.target.getAttribute && e.target.getAttribute('data-s'); if (!k) return;
        st[k] = e.target.value;
        if (k === 'sys') { st.band = D.bra[st.sys].band[0]; st.cup = D.bra[st.sys].cups[0]; render(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
    function sizeFs() {
      var vs = document.querySelector('variant-selects'); if (!vs) return null;
      return [].slice.call(vs.querySelectorAll('fieldset')).filter(function (f) { var g = f.querySelector('legend'); return g && /size|maat|مقاس/i.test(g.textContent); })[0] || null;
    }
    function modelLine() {
      var x = C.models[0], s = C.table.filter(function (r) { return r.n === x.s; })[0], sz = x.s + (s && s[REG] ? ' (' + s[REG] + ')' : '');
      if (D.L) return (C.preAr || 'كلتا العارضتين طولهما') + ' ' + x.h + ' وترتدي ' + sz;
      return (C.pre || 'Both models are') + ' ' + x.h + ', wearing ' + sz;
    }
    function modelBox() {
      var m = document.createElement('p'); m.className = 'dtsf-mod';
      m.innerHTML = HANGER + '<span>' + D.esc(modelLine()) + '</span>'; return m;
    }
    function injectAwrah() {
      if (document.querySelector('.dtsf-wrap')) return;
      var a = document.querySelector('.ks-container-app-block'); if (!a) return;
      var host = (a.closest && a.closest('.shopify-app-block, .shopify-block')) || a;
      document.documentElement.classList.add('dtsf-on');
      var w = document.createElement('div'); w.className = 'dtsf-wrap'; w.style.margin = '6px 0 16px';
      var b = document.createElement('button'); b.type = 'button'; b.className = 'dtsf-rbx'; b.innerHTML = boxHtml(); b.addEventListener('click', open); w.appendChild(b);
      if (C.models && C.models.length) { var m = modelBox(); m.style.margin = '8px 0 0'; w.appendChild(m); }
      host.parentNode.insertBefore(w, host);
    }
    function inject() {
      if (AWRAH) return injectAwrah();
      var fs = sizeFs(); if (!fs) return;
      document.documentElement.classList.add('dtsf-on'); fs.classList.add('dtsf-sz');
      var lg = fs.querySelector('legend');
      if (lg && !lg.querySelector('.dtsf-rbx')) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'dtsf-rbx'; b.innerHTML = boxHtml(); b.addEventListener('click', open); lg.appendChild(b);
      }
      [].slice.call(fs.querySelectorAll('input[type=radio]')).forEach(function (i) {
        var lb = fs.querySelector('label[for="' + i.id + '"]'); if (!lb || lb.getAttribute('data-dtsf')) return;
        var s = C.table.filter(function (x) { return x.n.toLowerCase() === String(i.value).toLowerCase(); })[0]; if (!s) return;
        lb.setAttribute('data-dtsf', '1'); lb.innerHTML = '<span class="dtsf-c1">' + s.n + '</span><span class="dtsf-c2">' + s[REG] + '</span>';
      });
      if (C.models && C.models.length && !document.querySelector('.dtsf-mod')) fs.parentNode.insertBefore(modelBox(), fs.nextSibling);
    }
    var raf = 0;
    build(); inject();
    new MutationObserver(function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; inject(); }); }).observe(document.body, { childList: true, subtree: true });
  }
  function go() { load(['deen-' + KIND + '-sf-data.js', 'deen-tops-sf-views.js'].concat(NOBRA ? ['deen-' + KIND + '-sf-views.js'] : []), run); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();